import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ThreadPage } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TData = ThreadPage;

export const useUniversalChatThreadsList = (
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query universalChatThreads {
      universalChatThreads {
        nodes {
          id
          engine
          title
          updatedAt
        }
      }
    }
  `;

  return useQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['useUniversalChatThreadsList'],
    queryFn: async () =>
      client.request({
        data: {
          gql: graphql
        }
      })
  });
};
